import { useCallback } from 'react'

import { useDynamicFontLoading } from './useDynamicFontLoading'

export function useFontCache() {
  const CACHE_KEY = 'makyo-font-cache'

  const { loadGoogleFont } = useDynamicFontLoading()

  const getCachedFonts = useCallback(() => {
    const cached = localStorage.getItem(CACHE_KEY)
    return cached ? JSON.parse(cached) : []
  }, [])

  const cacheFont = useCallback(
    (fontFamily: string) => {
      const cached = getCachedFonts()
      if (!cached.includes(fontFamily)) {
        cached.push(fontFamily)
        localStorage.setItem(CACHE_KEY, JSON.stringify(cached))
      }
    },
    [getCachedFonts]
  )

  const preloadCachedFonts = useCallback(() => {
    const cached = getCachedFonts()
    cached.forEach((fontFamily: string) => {
      loadGoogleFont(fontFamily)
    })
  }, [getCachedFonts, loadGoogleFont])

  return { cacheFont, preloadCachedFonts }
}
